import React from 'react'
import PropTypes from 'prop-types'

const DeleteIcon = (props) => {
  const { color = '#EF4444', classes = 'w-32' } = props
  return (
    <svg
      className={classes}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className={classes} rx="16" fill="white" />
      <path
        d="M10.6667 25.6004C10.08 25.6004 9.57779 25.3915 9.16001 24.9737C8.74223 24.5559 8.53334 24.0537 8.53334 23.4671V9.60039H7.46667V7.46706H12.8V6.40039H19.2V7.46706H24.5333V9.60039H23.4667V23.4671C23.4667 24.0537 23.2578 24.5559 22.84 24.9737C22.4222 25.3915 21.92 25.6004 21.3333 25.6004H10.6667ZM21.3333 9.60039H10.6667V23.4671H21.3333V9.60039ZM12.8 21.3337H14.9333V11.7337H12.8V21.3337ZM17.0667 21.3337H19.2V11.7337H17.0667V21.3337Z"
        fill={color}
      />
    </svg>
  )
}

DeleteIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(DeleteIcon)
